module.exports = __webpack_public_path__ + "static/assets/84beb1439e6ad814d5977c4f6fa5826d.svg";